import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const LanguageUrlSync = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const pathname = location.pathname;
    console.log('LanguageUrlSync - pathname:', pathname, 'current language:', i18n.language);
    
    // Force language change based on URL
    if (pathname.startsWith('/es/') || pathname === '/es') {
      console.log('Force switching to Spanish');
      i18n.changeLanguage('es');
    } else if (pathname.startsWith('/fr/') || pathname === '/fr' || pathname === '/') {
      console.log('Force switching to French');  
      i18n.changeLanguage('fr');
    }
  }, [location.pathname]);

  // Also run on mount to ensure correct initial language
  useEffect(() => {
    const pathname = location.pathname;
    if (pathname.startsWith('/es')) {
      i18n.changeLanguage('es');
    } else {
      i18n.changeLanguage('fr');
    }
  }, []);

  return null;
};